// Generated by ReScript, PLEASE EDIT WITH CARE

import * as HomeAtoms from "../../atoms/home/HomeAtoms.re.mjs";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as LucideReact from "lucide-react";
import * as Core from "@linaria/core";
import * as JsxRuntime from "react/jsx-runtime";

import { css, cx } from '@linaria/core'
;

import { t } from '@lingui/macro'
;

function highlights() {
  return [
    {
      title: t`Best Photo to Painting Service`,
      body: t`Instapainting is a platform for top independent artists and studios. Global artists and studios are vetted and each order is matched across hundreds of artists for the right skill and experience every single time.`
    },
    {
      title: t`Real Artists and Studios`,
      body: t`Artists are vetted based on their personal portfolios, exhibitions, and projects. Unlike other websites, your order won't be sent to a factory.`
    }
  ];
}

function promises() {
  return [
    {
      lead: t`Real paint — not digital.`,
      rest: t`Your photo becomes a real physical painting, not a digital one. The artist paints with real paint on real canvas.`
    },
    {
      lead: t`Direct from artist.`,
      rest: t`Communicate directly with a real artist — no middlemen or factory workers.`
    },
    {
      lead: t`Preview before it ships.`,
      rest: t`View your completed painting online and request revisions before it ships.`
    },
    {
      lead: t`Unlimited revisions.`,
      rest: JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          t`Our`,
          " ",
          JsxRuntime.jsx("em", {
            children: "BrushVision",
            className: Core.cx("italic")
          }),
          " ",
          t`technology makes it easy to see changes between revisions. Mark up your painting on our website easily.`
        ]
      })
    },
    {
      lead: t`Worldwide shipping.`,
      rest: t`Our artists ship worldwide with full tracking and insurance.`
    },
    {
      lead: t`A USA company.`,
      rest: t`We are a US-based corporation with offices in Washington state.`
    }
  ];
}

function FeaturesSection(props) {
  let highlights$1 = highlights();
  let promises$1 = promises();
  let highlightCount = HomeAtoms.pad(highlights$1.length);
  return JsxRuntime.jsx("section", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: Belt_Array.mapWithIndex(highlights$1, (idx, feature) => JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("p", {
                children: HomeAtoms.pad(idx + 1 | 0) + ` / ` + highlightCount,
                className: Core.cx("text-[10px] tracking-[0.3em] uppercase text-gray-400 font-light mb-4 tabular-nums")
              }),
              JsxRuntime.jsx(HomeAtoms.SerifHeading.make, {
                level: 3,
                children: feature.title,
                className: Core.cx("text-2xl md:text-3xl mb-5 leading-tight")
              }),
              JsxRuntime.jsx("p", {
                children: feature.body,
                className: Core.cx("text-gray-600 font-light leading-relaxed max-w-md")
              })
            ]
          }, String(idx))),
          className: Core.cx("grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 lg:gap-24 border-t border-gray-200 pt-12 md:pt-16")
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(HomeAtoms.Eyebrow.make, {
                  children: t`Our Guarantee`,
                  className: Core.cx("mb-6")
                }),
                JsxRuntime.jsxs("h3", {
                  children: [
                    t`100% Money Back Guarantee`,
                    JsxRuntime.jsx(LucideReact.Info, {
                      size: 14,
                      strokeWidth: 1.5,
                      className: Core.cx("text-gray-400 translate-y-[-2px]")
                    })
                  ],
                  className: Core.cx("font-serif font-extralight text-3xl md:text-4xl lg:text-5xl text-gray-900 tracking-tight inline-flex items-baseline gap-3")
                })
              ],
              className: Core.cx("text-center mb-12 md:mb-16")
            }),
            JsxRuntime.jsx("div", {
              children: Belt_Array.mapWithIndex(promises$1, (idx, promise) => JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("span", {
                    children: HomeAtoms.pad(idx + 1 | 0),
                    className: Core.cx("font-serif font-light text-sm text-gray-400 tabular-nums")
                  }),
                  JsxRuntime.jsxs("p", {
                    children: [
                      JsxRuntime.jsx("span", {
                        children: promise.lead,
                        className: Core.cx("text-gray-900")
                      }),
                      " ",
                      promise.rest
                    ],
                    className: Core.cx("text-gray-700 font-light leading-relaxed flex-1")
                  })
                ],
                className: Core.cx("flex items-baseline gap-6 py-5 border-t border-gray-200 last:border-b md:last:border-b-0")
              }, String(idx))),
              className: Core.cx("grid grid-cols-1 md:grid-cols-2 md:gap-x-16 lg:gap-x-24")
            })
          ],
          className: Core.cx("mt-24 md:mt-32")
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(HomeAtoms.Eyebrow.make, {
              children: t`The Idea`,
              className: Core.cx("mb-6")
            }),
            JsxRuntime.jsx(HomeAtoms.SerifHeading.make, {
              level: 3,
              children: t`Why custom artwork?`,
              className: Core.cx("text-3xl md:text-4xl lg:text-5xl mb-8")
            }),
            JsxRuntime.jsx("p", {
              children: t`Turn your favorite photo — even low quality ones — into a beautiful painted picture by a real artist. Get them the ultimate personalized gift: a custom portrait painting.`,
              className: Core.cx("max-w-2xl mx-auto text-gray-600 font-light leading-relaxed text-base md:text-lg")
            })
          ],
          className: Core.cx("mt-24 md:mt-32 border-t border-gray-200 pt-16 md:pt-20 text-center")
        })
      ],
      className: Core.cx("max-w-6xl mx-auto")
    }),
    className: Core.cx("w-full bg-[#faf9f6] px-6 md:px-12 pb-24 md:pb-32")
  });
}

let make = FeaturesSection;

export {
  highlights,
  promises,
  make,
}
/*  Not a pure module */
